module.exports = __webpack_public_path__ + "static/media/oval-blue.cb3d5410.svg";